import { render } from "./business-address.vue?vue&type=template&id=57bdc68e&scoped=true"
import script from "./business-address.vue?vue&type=script&lang=js"
export * from "./business-address.vue?vue&type=script&lang=js"

import "./business-address.vue?vue&type=style&index=0&id=57bdc68e&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bdc68e"]])

export default __exports__